import React from 'react';
import Login from './home-login.js';
import SignUp from './home-sign-up.js';
import { Routes, Link, Route } from "react-router-dom";
import * as util from '../../other/util.js';

// The home page of the game
class HomePageView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show_change_log: false,
        };
    }

    render() {
        return (
            <div style={{ "width": "900px", "margin": "auto" }}>
                <h1>Space Nations</h1>
                <div style={{ "margin": "auto", "width": "600px" }}>
                    {this.getStory()}
                    <br />
                    <Routes>
                        <Route path="/" exact element={<ChoseButtons />} />
                        <Route path="/login" exact
                            element={<Login {...this.props} onLogin={() => this.handleDidLogin()} />} />
                        <Route path="/signup" exact
                            element={<SignUp {...this.props} onDidSignUp={() => this.handleDidSignUp()} />} />
                        <Route path="/*" exact element={<ChoseButtons />} />
                    </Routes>
                    <br />
                    {this.getFeatures()}
                </div>
            </div>
        );
    }

    handleDidLogin() {
        this.props.navigate('/game/dashboard');
    }

    handleDidSignUp() {
        this.props.navigate('/game/dashboard');
    }

    handleToggleChangeLog() {
        this.setState({ show_change_log: !this.state.show_change_log });
    }

    getStory() {
        return (
            <p className="quest-story-text" style={{ "textAlign": "center" }}>
                As the ruler of a planet, the fate of your empire is at your finger tips.<br />
                Build your civilization and reach out for the stars.<br />
                Colonize the galaxy and make it your own.<br />
                Form alliances among your friends.<br />
                Destroy those who appose you.<br />
                And: just have fun :)
            </p>
        );
    }

    getFeatures() {
        return (
            <div>
                <p>
                    <b>What makes Space Nations a next level browser game:</b>
                </p>

                <ul>
                    <li>
                        Battle not only other players (PvP), but also dynamic AI empires based on naturally occurring neural networks.
                        Face galaxy-wide events, contested sectors, and cunning computer-controlled fleets.
                    </li>
                    <li>
                        Shape the origin story of your civilization and lead it through a rich, evolving narrative filled with challenges.
                        Design your own space ships!
                    </li>
                    <li>
                        There are few set rules. Players are able to come together to define their own laws for
                        the galaxy. However, some players might not always chose to follow these rules. It is up
                        to you to enforce them.
                    </li>
                    <li>
                        Regular updates and path-fining fixes coming in .. <Link className="link-button" to={{ pathname: '/change-log', force_update: true }}> view list
                        </Link>
                    </li>
                </ul>
            </div>
        );
    }
}

class ChoseButtons extends React.Component {
    render() {
        return (
            <div style={{ "textAlign": "center" }}>
                <div style={{ "display": "inline-block" }}>
                    <Link className="cool-button" to={{ pathname: '/login', force_update: true }}>log in</Link>
                    <span style={{ "margin": "20px" }} />
                    <Link className="cool-button" to={{ pathname: '/signup', force_update: true }}>Sign up</Link>
                </div>
            </div>
        );
    }
}

export default util.withNavigation(HomePageView);
